import { Guard } from '../../../common/guards/guard';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { WorkspaceCategoryMetricsUsagePerIndividualTimeSeriesAggregateRootMapper } from '../../../infrastructure/mappers/app-category-metrics/workspace-category-metrics-usage-per-individual-time-series.aggregate-root.mapper';
import { GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesRequestDto } from '../../dtos/app-category-metrics/get-workspace-category-metrics-usage-per-individual-time-series.request.dto';
import { GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesResponseDto } from '../../dtos/app-category-metrics/get-workspace-category-metrics-usage-per-individual-time-series.response.dto';
import { GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesQuery } from '../../queries/app-category-metrics/get-workspace-category-metrics-usage-per-individual-time-series.query';

export class GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesQuery,
    protected readonly mapper: WorkspaceCategoryMetricsUsagePerIndividualTimeSeriesAggregateRootMapper
  ) {}

  async get(
    props: GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesRequestDto
  ): Promise<GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesResponseDto> {
    try {
      const { segment, granularity } = props.params;

      const isGranularityEmpty = Guard.isEmpty(granularity);
      const isSegmentEmpty = Guard.isEmpty(segment);

      if (!isGranularityEmpty && !isSegmentEmpty) {
        throw new Error(
          'Cannot provide both granularity and weekday parameters'
        );
      }

      if (isGranularityEmpty && isSegmentEmpty) {
        throw new Error('No granularity or weekday parameters provided');
      }

      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetWorkspaceCategoryMetricsUsagePerIndividualTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
